<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger v-if="device=='desktop'" class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container2" @command="chooseLanuage">
      <span class="el-dropdown-link">
        <img src="static/img/english.png" style="width:35px;height:35px;margin-top:10px;">

      </span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-plus"  command="en">English</el-dropdown-item>
        <el-dropdown-item icon="el-icon-circle-plus"  command="zh">Chinese</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div style="width:1px;background-color: #DCDFE6;color:#DCDFE6;
    margin-top:10px;height: 30px;position: absolute;right: 85px;"class="avatar-container3" ></div>

    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            {{ $t('navbar.home') }}
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">{{ $t('navbar.logout') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    device() {
      return this.$store.state.app.device
    },
  },
  methods: {
    chooseLanuage(lang){
      localStorage.setItem('lang', lang)

      this.$i18n.locale = lang; // 修改当前语言
      location.reload() // 为了重新实例化vue-router对象 避免bug
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }

  .avatar-container2 {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 95px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .avatar-container3 {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 90px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue